import Alert from "@mui/material/Alert";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PalletSummaryTotals } from "../../types/pallet-summary.type";
import { numberWithCommas } from "../../utils";
import { formatPalletCount } from "./palletSummary";

interface SummaryCardProps {
  title: string;
  count: number;
}

function SummaryCard({ title, count }: Readonly<SummaryCardProps>) {
  return (
    <Paper variant="outlined" sx={{ flex: 1, p: 1.5 }}>
      <Typography variant="body2" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="h5" fontWeight={700}>
        {formatPalletCount(count)}
      </Typography>
    </Paper>
  );
}

/** The headline figures of the level on screen — every branch, one branch or one route. */
export default function PalletSummaryCards({
  totals,
}: Readonly<{ totals: PalletSummaryTotals }>) {
  const hasIncompleteTrips = totals.incomplete_trip_count > 0;
  const incompleteNote = `มี ${numberWithCommas(totals.incomplete_trip_count)} รอบที่ข้อมูลยังไม่ครบ`;

  return (
    <Stack gap={2} mb={2}>
      <Stack direction={{ xs: "column", sm: "row" }} gap={2}>
        <SummaryCard title="ถาดขึ้นรวม" count={totals.pallet_out} />
        <SummaryCard title="ถาดกลับรวม" count={totals.pallet_in} />
        <SummaryCard title="ส่วนต่าง (กลับ − ขึ้น)" count={totals.pallet_diff} />
      </Stack>
      {hasIncompleteTrips && <Alert severity="warning">{incompleteNote}</Alert>}
    </Stack>
  );
}
